import React from 'react';
import { demoMetrics } from '../../../Demo/data';
import FilterMetricsSelector from '../../../../../../../common/components/Form/filterInputs/MetricsSelect';

function Metrics(props) {
  const {
    show, demo, value, onChange, onClose,
  } = props;

  if (!show) {
    return null;
  }

  return (
    <FilterMetricsSelector
      options={demo ? demoMetrics : null}
      className="filter filter-metric"
      label="Metrics:"
      multiple
      value={value}
      name="metrics"
      onChange={onChange}
      onClose={onClose}
      showCheckboxes
    />
  );
}

export default Metrics;
